import { render } from "./RadioDetail.vue?vue&type=template&id=56724b2e"
import script from "./RadioDetail.vue?vue&type=script&lang=js"
export * from "./RadioDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__